import Link from 'next/link';
import { useRouter } from 'next/router';
import { List, Link as MuiLink } from '@mui/material';

import { headerNavList } from './headerNavList';

const DesktopList = () => {
  const router = useRouter();

  return (
    <List className="desktopNavList">
      {headerNavList.map(({ url, name }) => (
        <li key={url}>
          <Link passHref href={url}>
            <MuiLink
              type="desktopNavItem"
              className={router.pathname === url ? 'selected' : ''}
            >
              {name}
            </MuiLink>
          </Link>
        </li>
      ))}
    </List>
  );
};

export default DesktopList;
